import { readUrlStateSlice, withUrlStateSlice } from "@/common/helpers/url-state";
import { useCallback } from "react";
import { useSearchParams } from "wouter";

type SetUrlStateSlice<T> = (slice: T | undefined) => void;

export function useUrlStateSlice<T>(sliceKey: string): [T | undefined, SetUrlStateSlice<T>] {
  const [searchParams, setSearchParams] = useSearchParams();

  const slice = readUrlStateSlice<T>(searchParams, sliceKey);

  const setSlice = useCallback<SetUrlStateSlice<T>>(
    (next) => {
      setSearchParams((currentParams) => withUrlStateSlice(currentParams, sliceKey, next));
    },
    [setSearchParams, sliceKey],
  );

  return [slice, setSlice];
}
